import Main from "niteroi/packages/customer-services/controllers/Main.controller";
export default class Clients extends Main {
    public onInit(): void {
        super.onInit();
    }

    public onPressCreateClients(): void {
        this.navTo("customer-services/clients/add", {}, true);
    }
}
